/* eslint-disable @typescript-eslint/no-namespace */
export namespace Line {
    export enum DeliveryStatus {
        Active = 'ACTIVE',
        Paused = 'PAUSED',
        Removed = 'REMOVED',
        NotDelivering = 'NOT_DELIVERING',
        NotApproved = 'NOT_APPROVED',
    }

    export enum ConfiguredStatus {
        Active = 'ACTIVE',
        Paused = 'PAUSED',
        Removed = 'REMOVED',
        Draft = 'DRAFT',
    }

    export enum SpendingLimitType {
        None = 'NONE',
        Monthly = 'MONTHLY',
        Lifetime = 'LIFETIME',
    }

    export type Campaign = {
        id: number;
        name: string;
        startDate: string;
        endDate: string;
        configuredStatus: ConfiguredStatus;
        deliveryStatus: DeliveryStatus;
        spendingLimitType: SpendingLimitType;
        campaignObjective?: string;
        createdDate: string;
        externalAdsManagerUrl?: string;
    };

    export type Targeting = {
        targetingMode?: 'MANUAL' | 'AUTO';
        country?: string;
        excludedCustomAudienceIds?: string[];
    };

    export type AdGroup = {
        id: number;
        name: string;
        configuredStatus: ConfiguredStatus;
        deliveryStatus: DeliveryStatus;
        targeting?: Targeting;
        dailyBudgetMicro?: number;
        createdDate: string;
        externalAdsManagerUrl?: string;
    };

    export type Ad = {
        id: number;
        name: string;
        adgroupId: number;
        creative?: Creative;
        configuredStatus: ConfiguredStatus;
        deliveryStatus: DeliveryStatus;
        createdDate: string;
        externalAdsManagerUrl?: string;
    };

    export type ReviewStatus = 'SKIPPED_REVIEW' | 'IN_REVIEW' | 'APPROVED' | 'REJECTED';

    /** Media embedded in creative objects (LINE API doesn't include id/name). */
    export type EmbeddedMedia = {
        id?: number;
        name?: string;
        mediaType: string;
        url?: string;
        object?: {
            fileName?: string;
            sourceUrl?: string;
        };
    };

    export type Creative = {
        id: number;
        creativeFormat:
            | 'IMAGE'
            | 'VIDEO'
            | 'CAROUSEL'
            | 'SMALL_IMAGE'
            | 'SMALL_IMAGE_CPF'
            | 'IMAGE_ANIMATION'
            | 'IMAGE_ANIMATION_CPF'
            | 'SMALL_VIDEO';
        title?: string;
        description?: string;
        longTitle?: string;
        image?: EmbeddedMedia;
        smallImage?: EmbeddedMedia;
        video?: EmbeddedMedia;
        animation?: EmbeddedMedia;
        reviewStatus?: ReviewStatus;
    };

    /** Standalone media entities from LINE /media endpoint. */
    export type Media = {
        id: number;
        name: string;
        mediaType: 'IMAGE' | 'VIDEO' | 'APP' | 'URL' | 'ANIMATION';
        url?: string;
        object?: {
            sourceUrl?: string;
        };
        reviewStatus?: ReviewStatus;
        createdDate?: string;
    };
}
